import classNames from 'classnames';
import { FieldPath, FieldValues, PathValue, useController, UseControllerProps } from 'react-hook-form';
import { Icon, IconIdentifier, Tooltip } from '@steelbuy/ui-primitive';

import '../number-input/NumberInput.scss';

interface TextInputProps<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> extends UseControllerProps<TFieldValues, TName> {
    error?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    name: any;
}

export const TextInput = <
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
    control,
    rules,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    error,
    ...rest
}: TextInputProps<TFieldValues, TName>) => {
    const { field } = useController({
        control,
        rules: {
            ...(rules || {}),
            validate: (value: PathValue<TFieldValues, TName>, formValues: TFieldValues) => {
                if (rules?.validate && typeof rules.validate === 'function') {
                    return rules.validate(value, formValues);
                }
                return true;
            },
        },
        ...rest,
    });

    const formInputClassMap = {
        'form-input': true,
        'form-input--disabled': false,
    };

    const formInputFieldClassMap = {
        'form-input__field': true,
        'form-input__field--disabled': false,
        'form-input__field--error': !!error,
        'form-input__field--error--endAdornment': false,
        'form-input__field--read-only': false,
    };
    const formInputFieldInputClassMap = {
        'form-input__field__input': true,
        'form-input__field__input--disabled': false,
        'form-input__field__input--read-only': false,
        'form-input__field__input--error': !!error,
    };

    return (
        <div className={classNames(formInputClassMap)}>
            <span className={classNames(formInputFieldClassMap)}>
                <input {...field} type="text" className={classNames(formInputFieldInputClassMap)} />
                {!!error && (
                    <Tooltip content={error}>
                        <span className="icon__position">
                            <Icon name={IconIdentifier.ERROR} />
                        </span>
                    </Tooltip>
                )}
            </span>
        </div>
    );
};
